import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import toLower from 'lodash/toLower';
import get from 'lodash/get';
import noop from 'lodash/noop';
import filter from 'lodash/filter';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
// Site Components import
import CAMErrorComponent from 'yoda-account-components/lib/components/CAMErrorComponent/CAMErrorComponent';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import MiniPDPInterstitial from 'yoda-mini-pdp/lib/components/MiniPDPInterstitial/MiniPDPInterstitial';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ItemRemovedMessageBox from 'yoda-checkout-components/lib/components/ItemRemovedMessageBox/ItemRemovedMessageBox';
import Loading from 'yoda-site-components/lib/components/Loading/Loading';
import DefaultList from '../../../../components/Lists/DefaultList/DefaultList';
import ItemTile from '../../../../components/Lists/ItemTile/ItemTile';
import ListItemPreShellLoader from '../../../../components/Lists/PreShellLoaders/ListItemPreShellLoader';
import { getSavedItems } from '../../../../common/getSavedItems';

import * as styles from './ListDetailsPanel.css';

const cx = classNames.bind(styles);
class ListDetailsPanel extends SiteComponent {
    static propTypes = {
        actions: PropTypes.objectOf.isRequired,
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCartActions: PropTypes.objectOf(PropTypes.object).isRequired,
        createList: PropTypes.func.isRequired,
        deviceType: PropTypes.objectOf.isRequired,
        draftOrder: PropTypes.objectOf(PropTypes.object).isRequired,
        headers: PropTypes.objectOf.isRequired,
        id: PropTypes.string.isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        isOOSListingEnabled: PropTypes.bool.isRequired,
        listLandingError: PropTypes.bool.isRequired,
        LoaderAction: PropTypes.objectOf(PropTypes.object).isRequired,
        location: PropTypes.objectOf.isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        MiniPDPActions: PropTypes.objectOf(PropTypes.object).isRequired,
        mountOnServer: PropTypes.bool.isRequired,
        openSlider: PropTypes.func.isRequired,
        savedList: PropTypes.objectOf.isRequired,
        showTopMessage: PropTypes.func.isRequired,
        toggleMostWanted: PropTypes.objectOf.isRequired,
        closeParentDialog: PropTypes.func,
        pageEvent: PropTypes.func,
        error: PropTypes.objectOf,
        updatedItem: PropTypes.objectOf(PropTypes.object),
        myAlertsProps: PropTypes.object,
        lastRemovedListItem: PropTypes.object,
        closeMessageBox: PropTypes.func,
        enableMiniPDPFeature: PropTypes.bool.isRequired,
    };

    static defaultProps = {
        closeParentDialog: noop,
        pageEvent: noop,
        error: {},
        isOOSListingEnabled: false,
        messagesTexts: {},
        myAlertsProps: {},
        lastRemovedListItem: {},
    };

    constructor(props) {
        super(props);
        const isTrendingList = props.isTrendingList === 'true';
        const itemsCount = get(props.savedList, 'data.items', []).length || 2;
        this.state = {
            showMessage: false,
            message: '',
            type: '',
            updatedItem: false,
            isTrendingList,
            isListPrivate: false,
            isListingDown: false,
            isLoaded: false,
            itemsCount,
        };
    }

    hydrateOnMount() {
        const { id, headers, savedList = {}, actions, deviceType, location } = this.props;
        const { isTrendingList } = this.state;
        let accountId;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        /* istanbul ignore else */
        if (query.token) {
            accountId = query.accountId;
        }
        const userState = get(headers, 'cookies.DP_USER_STATE', '0'); // so that if undefined should be treated as '0'
        if (userState !== '0' && !savedList.data && !isTrendingList) {
            const device = deviceType.isDesktop ? 'desktop' : 'mobile';
            /* istanbul ignore else */
            if (!__SERVER__) {
                this.getSavedListCalledOnHydrate = true;
            }
            actions.getSavedLists(
                id,
                1,
                50,
                null,
                device,
                null,
                get(query, 'token', ''), // token will add later
                accountId, // accountId will add later
                headers,
                isTrendingList,
                false
            );
        }
    }

    componentDidMount() {
        /** We need this for getting data from localStorage and calling api myfavorites not
         * coming for guest user right now
         */
        const { id, isLoggedIn, location } = this.props;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        const { isTrendingList } = this.state;
        let localData = '';
        localData = !isLoggedIn && getSavedItems('0', false, false, id);
        !this.getSavedListCalledOnHydrate &&
            !isTrendingList &&
            this.props.actions.getSavedLists(
                this.props.id,
                1,
                50,
                null,
                'desktop',
                localData,
                get(query, 'token', ''),
                get(query, 'accountId', ''),
                null,
                isTrendingList,
                !isLoggedIn
            );
    }

    componentWillReceiveProps(nextProps) {
        const { toggleMostWanted, deleteList, savedList, location, error } = nextProps;
        const listingError = get(nextProps, 'error.errorCode', '');
        const updateCallFails = get(nextProps, 'updatedItem.updateListError.error.errorCode', '');
        const deleteCallFails = get(nextProps, 'deleteList.deleteListError.error.errorCode', '');
        const movedToList = get(nextProps, 'MTLSavedLists.movedToList.error.errorCode', '');
        const listingStatusCode = get(nextProps, 'error.statusCode', '');
        const search = get(location, 'search', '');
        const nextPropsListItemsLength = get(nextProps.savedList, 'data.items', []).length;
        const query = makeQuery(search);
        const { myListing: { validErrorCodes = [] } = {} } = this.props;

        if (
            !isEmpty(toggleMostWanted) &&
            toggleMostWanted !== this.props.toggleMostWanted &&
            toggleMostWanted.response.status === 204
        ) {
            this.getSavedListAction();
        }
        if (
            !isEmpty(deleteList) &&
            get(deleteList, 'response.status') === 204 &&
            get(this.props, 'deleteList.response.status') !==
                get(nextProps, 'deleteList.response.status')
        ) {
            this.getSavedListAction();
        }

        if (this.state.updatedItem && get(nextProps, 'updatedItem.response.status') === 204) {
            this.setState(
                {
                    updatedItem: false,
                },
                () => {
                    this.getSavedListAction();
                }
            );
        }

        if (this.props.isLoggedIn !== nextProps.isLoggedIn) {
            this.getSavedListAction({ isGuestMode: !nextProps.isLoggedIn });
        }

        if (
            get(savedList, 'error.statusCode') &&
            savedList.error.statusCode === 412 &&
            get(query, 'token')
        ) {
            this.setState({ isListPrivate: true });
        }
        const isServiceDown = updateCallFails || deleteCallFails || movedToList;
        if (
            error &&
            (validErrorCodes.indexOf(listingError) > -1 ||
                listingStatusCode === 500 ||
                isServiceDown)
        ) {
            this.setState({
                isListingDown: true,
                isLoaded: true,
            });
        }

        if (nextProps.listLandingError) {
            this.setState({
                showMessage: false,
            });
        }

        if (!!nextPropsListItemsLength && nextPropsListItemsLength !== this.state.itemsCount) {
            this.setState({
                itemsCount: nextPropsListItemsLength,
            });
        }
    }

    moveToListSuccess = (listMovedTo, listMovedId) => {
        this.showTopMessage('success', 'Item has been moved to ', listMovedTo, listMovedId);
        this.props.actions.deleteLastRemovedItem();
        this.getSavedListAction();
    };

    addToListSuccess = (listAddedTo, listAddedToId) => {
        this.showTopMessage('success', 'Item has been added to ', listAddedTo, listAddedToId);
        this.props.actions.deleteLastRemovedItem();
        this.getSavedListAction();
    };

    updateItem = (payloadParam) => {
        const payload = { ...payloadParam };
        /* eslint-disable no-new */
        return new Promise((resolve) => {
            payload.product = {
                id: payload.ppId,
            };
            payload.itemId = payload.skuId;

            const myAlerts = {
                isOOSPro: true,
            };

            payload.myAlerts = myAlerts;
            this.props.MiniPDPActions.updateItems(payload);
            this.setState({
                updatedItem: true,
            });
            resolve('Updated Items');
        });
    };

    getSavedListAction(nextProps) {
        const { id, isLoggedIn, location } = this.props;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        const { isTrendingList } = this.state;
        const deviceType = this.props.deviceType.isDesktop ? 'desktop' : 'mobile';
        let isGuestMode = get(nextProps, 'isGuestMode', 'NA');
        if (isGuestMode === 'NA') {
            isGuestMode = !isLoggedIn;
        }
        this.props.actions.getSavedLists(
            id,
            1,
            50,
            null,
            deviceType,
            null,
            get(query, 'token', ''),
            get(query, 'accountId', ''),
            null,
            isTrendingList,
            isGuestMode
        );
    }

    closeMessageBox = () => {
        this.setState({
            showMessage: false,
        });
    };

    showTopMessage = (type, message, movedTo = '', movedId = '') => {
        this.props.closeParentDialog();
        this.props.showTopMessage(type, message, movedTo, movedId);
        // this.setState({
        //     showMessage: true,
        //     message,
        //     type,
        //     movedTo,
        //     movedId,
        // });
    };

    findOutOfStockItemsCount = (productsList) =>
        filter(
            productsList,
            (list) =>
                (list.inventory && toLower(list.inventory.message) === 'out of stock online') ||
                (list.inventory && list.inventory.atp && list.inventory.quality === 'low')
        ).length;

    showOutOfStockAlertLabel = (data) => {
        const isInventoryMessageValid =
            toLower(get(data, 'inventory.message', '')) === 'out of stock online';
        const isPricingAttributes =
            toLower(get(data, 'pricing.couponInfo.marketingLabel', '')) === 'closeout!';
        const isZipValid = get(data, 'deliveryAvailabilityCheckRequired', '') === true;
        const getAmounts = get(data, 'pricing.amounts', []);
        const isAmountsTypeValid =
            getAmounts &&
            getAmounts.some(
                (amount) => ['clearance', 'discontinued'].indexOf(toLower(amount.type)) > -1
            );
        const checkAllOOSScenarios =
            isInventoryMessageValid && !isPricingAttributes && !isZipValid && !isAmountsTypeValid;
        return checkAllOOSScenarios;
    };

    render() {
        const {
            actions,
            id,
            isLoggedIn,
            LoaderAction,
            addToCartActions,
            addToCart,
            savedList = {},
            deviceType,
            MiniPDPActions,
            location,
            openSlider,
            showTopMessage,
            createList,
            messagesTexts,
            isOOSListingEnabled,
            myAlertsProps,
            lastRemovedListItem,
            closeMessageBox,
            enableMiniPDPFeature,
        } = this.props;
        let isLoaded = get(savedList, 'isLoaded', false);
        if (this.state.isListingDown) {
            isLoaded = this.state.isLoaded;
        }
        const { isTrendingList } = this.state;
        const itemTileProps = {
            LoaderAction,
            addToCartActions,
            addToCart,
            catList: {
                listId: id,
                listName: get(savedList, 'data.name', 'My Favorites'),
            },
            deviceType,
            actions,
            isLoggedIn,
            MiniPDPActions,
            isTrendingList,
            closeMessageBox,
        };
        const { isListPrivate } = this.state;
        const defaultErrorMap = get(messagesTexts, 'myListing.errorCodes.DEFAULT', '');
        let productView = <span />;
        const productsList = get(savedList, 'data.items', []);
        const products = productsList.map((data, index) => {
            if (!isEmpty(lastRemovedListItem) && lastRemovedListItem.removedIndex === index) {
                productView = (
                    <>
                        <ItemRemovedMessageBox removedItem={lastRemovedListItem} />
                        <ItemTile
                            location={location}
                            data={data}
                            key={data.id}
                            index={index}
                            updateItem={this.updateItem}
                            totalItems={productsList.length}
                            moveToListSuccess={this.moveToListSuccess}
                            addToListSuccess={this.addToListSuccess}
                            showTopLevelMessage={showTopMessage}
                            showTopMessage={this.showTopMessage}
                            createList={createList}
                            openSlider={openSlider}
                            savedActions={this.props.actions}
                            pageEvent={this.props.pageEvent}
                            draftOrder={this.props.draftOrder}
                            isLoggedIn={isLoggedIn}
                            messagesTexts={messagesTexts}
                            isOOSAlert={isOOSListingEnabled && this.showOutOfStockAlertLabel(data)}
                            myAlertsProps={myAlertsProps}
                            {...itemTileProps}
                        />
                    </>
                );
            } else if (
                !isEmpty(lastRemovedListItem) &&
                lastRemovedListItem.removedIndex >= productsList.length - 1 &&
                index === productsList.length - 1
            ) {
                productView = (
                    <>
                        <ItemTile
                            location={location}
                            data={data}
                            key={data.id}
                            index={index}
                            updateItem={this.updateItem}
                            totalItems={productsList.length}
                            moveToListSuccess={this.moveToListSuccess}
                            addToListSuccess={this.addToListSuccess}
                            showTopLevelMessage={showTopMessage}
                            showTopMessage={this.showTopMessage}
                            createList={createList}
                            openSlider={openSlider}
                            savedActions={this.props.actions}
                            pageEvent={this.props.pageEvent}
                            draftOrder={this.props.draftOrder}
                            isLoggedIn={isLoggedIn}
                            messagesTexts={messagesTexts}
                            isOOSAlert={isOOSListingEnabled && this.showOutOfStockAlertLabel(data)}
                            myAlertsProps={myAlertsProps}
                            {...itemTileProps}
                        />
                        <ItemRemovedMessageBox removedItem={lastRemovedListItem} />
                    </>
                );
            } else {
                productView = (
                    <ItemTile
                        location={location}
                        data={data}
                        key={data.id}
                        index={index}
                        updateItem={this.updateItem}
                        totalItems={productsList.length}
                        moveToListSuccess={this.moveToListSuccess}
                        addToListSuccess={this.addToListSuccess}
                        showTopLevelMessage={showTopMessage}
                        showTopMessage={this.showTopMessage}
                        createList={createList}
                        openSlider={openSlider}
                        savedActions={this.props.actions}
                        pageEvent={this.props.pageEvent}
                        draftOrder={this.props.draftOrder}
                        isLoggedIn={isLoggedIn}
                        messagesTexts={messagesTexts}
                        isOOSAlert={isOOSListingEnabled && this.showOutOfStockAlertLabel(data)}
                        myAlertsProps={myAlertsProps}
                        {...itemTileProps}
                    />
                );
            }
            return productView;
        });
        return (
            <div
                data-automation-id="list-details-panel"
                className={`${cx('ListDetailsPanel')} ${dt(['clear-both', 'smOnly:mb-2', 'mb-4'])}`}
            >
                {!isLoaded && isEmpty(productsList) && (
                    <ListItemPreShellLoader count={this.state.itemsCount} />
                )}
                {enableMiniPDPFeature && <MiniPDPInterstitial />}
                {!this.state.isListingDown && products}
                <Loading />
                {this.state.isListingDown && (
                    <CAMErrorComponent
                        classes={{ wrapper: cx('errorComponent') }}
                        type="page-level"
                        errorDetails={{
                            message: defaultErrorMap.message,
                            title: defaultErrorMap.title,
                        }}
                        onRetry={this.getMyListing}
                    />
                )}
                {isLoaded &&
                    !this.state.isListingDown &&
                    isEmpty(productsList) &&
                    !isEmpty(lastRemovedListItem) && (
                        <ItemRemovedMessageBox removedItem={lastRemovedListItem} />
                    )}
                {isLoaded && !this.state.isListingDown && isEmpty(productsList) && (
                    <DefaultList isSharedPrivate={isListPrivate} />
                )}
                {!deviceType.isMobile &&
                    isOOSListingEnabled &&
                    this.findOutOfStockItemsCount(productsList) > 0 && (
                        <div className={cx('OOS-container')}>
                            <img
                                src="/static-listing/assets/svg/warning.svg"
                                alt="warning"
                                className={cx('warning-icon')}
                            />
                            <p className={cx('OOS-label')}>
                                {this.findOutOfStockItemsCount(productsList)}{' '}
                                {this.findOutOfStockItemsCount(productsList) === 1
                                    ? 'item'
                                    : 'items'}{' '}
                                low or out of stock
                            </p>
                        </div>
                    )}
            </div>
        );
    }
}

export default ListDetailsPanel;
